(() => {
  let lastTrigger = null;
  const getModal = () => document.querySelector('#search-modal');

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || event.defaultPrevented) return;
    const trigger = event.target.closest('[data-mh-search-open]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const modal = getModal();
    if (!modal || typeof modal.showDialog !== 'function') return;
    event.preventDefault();
    lastTrigger = trigger;
    modal.showDialog();
  });

  const connect = () => {
    const modal = getModal();
    if (!modal || modal.dataset.mhEntryReady === 'true') return;
    modal.dataset.mhEntryReady = 'true';
    const triggers = () => document.querySelectorAll('[data-mh-search-open]');
    const update = (expanded) => triggers().forEach((trigger) => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'search-modal-dialog');
      trigger.setAttribute('aria-expanded', String(expanded));
    });
    update(false);
    modal.addEventListener('dialog:open', () => {
      update(true);
      modal.querySelector('input[type="search"]')?.focus({ preventScroll: true });
    });
    modal.addEventListener('dialog:close', () => {
      update(false);
      if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();
